:host {
  align-items: center;
  background: var(--ux-notification-bell-background);
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  position: relative;
}

#content {
  position: relative;
}

#icon {
  font-size: var(--ux-notification-bell-icon-font-size);
}

#badge {
  display: inline-flex;
  font-size: 0;
  left: var(--ux-notification-bell-badge-left-pos);
  margin-left: var(--ux-notification-bell-badge-margin-left-pos);
  position: var(--ux-notification-bell-badge-position);
  top: var(--ux-notification-bell-badge-top-pos);
}